<!-- The docked Ryn/wren avatar (walkthrough-wren, in-app-help) is the sole
     launcher: it calls AskRynUiService.open() on its docked click. The earlier
     "page reloads on click" symptom was never the wren's click path (the docked
     click always reached open()); it was a bridge 401 reaching the app-wide
     GlobalErrorHandler, now handled inside AskRynComponent. So the diagnostic
     fallback button is removed and the wren stands alone, per the intended
     single-launcher design. -->
@if (ui.isOpen() && ui.canUse()) {
  <div
    class="ask-ryn-panel"
    role="dialog"
    aria-label="Ask Ryn"
    [style.left.px]="left()"
    [style.top.px]="top()"
    [style.width.px]="width()"
    [style.height.px]="height()"
    [style.right]="'auto'"
    [style.bottom]="'auto'"
  >
    <!-- Top-left resize handle: drag to grow the panel up-and-left while the
       bottom-right corner stays docked. -->
    <div
      class="ask-ryn-panel__resize"
      aria-hidden="true"
      (mousedown)="startResize($event)"
    ></div>
    <div class="ask-ryn-panel__header" (mousedown)="startMove($event)">
      <span class="ask-ryn-panel__title">Ask Ryn</span>
      <button
        type="button"
        class="ask-ryn-panel__close"
        aria-label="Close"
        (click)="ui.close()"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="ask-ryn-panel__body">
      <ups-ask-ryn
        [userId]="userId()"
        [userDisplayName]="userDisplayName()"
        [appId]="appId"
        [appName]="appName"
        [pageUrl]="currentUrl()"
      ></ups-ask-ryn>
    </div>
  </div>
}
